export default __webpack_public_path__ + "static/myteam-8f19afcf0dbd21f7d5de7c308db8abde.png";